import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
  Button,
  Center,
  Flex,
  Image,
  Link,
  Spacer
} from '@chakra-ui/react';

import Sidebar from '../sidebar/sidebar';
import logo from '../../assets/images/soma-logo.png';
import { useState } from 'react';

const getUser = () => JSON.parse(sessionStorage.getItem('user'));

export const Header = () => {
  const [user] = useState(getUser);
  const navigate = useNavigate();

  const logout = () => {
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('token');
    navigate("/login");
  }

  return (
    <Flex direction='row' width='99%' my='2' mx='auto' px='3' border='1px' borderRadius='10' borderColor='gray.200'>
      <Center><Sidebar /></Center>
      
      <Spacer />
      
      <Link as={RouterLink} to="/">
        <Image boxSize="80px" objectFit="scale-down" src={logo} alt="enterprise logo" cursor="pointer" />
      </Link>
      
      <Spacer />
      
      <Center><Button colorScheme='blue' type='button' onClick={ logout }>Logout</Button></Center>
    </Flex>
  );
}
